import { useEffect, useState } from "react";
import { getQueryParams } from "../RouteWithSubRoutes";
import { pageNames } from "../../reduxStore/reducers/main";
import { useHistory } from "react-router-dom";
import { nativeStorageInterface } from "../..";
import {noIntro} from "./useURLParams.sideEffects";

export function useCheckIntroAndCookiePiKey(props) {
  const [initRun, setInitRun] = useState(true);
  const history = useHistory();

  const handlePageDirect = () => {
    if (props.piKeyState === undefined || !initRun) return;
    setInitRun(false);

    const searchParams = new URLSearchParams(props.location.search);
    const urlPiKey = props.piKeyState;
    nativeStorageInterface.get("piKey").then((r) => {
      const savedPiKey = r ?? false;
      const piKey = urlPiKey ?? savedPiKey;

      nativeStorageInterface.get("introComplete").then((r2) => {
        let introComplete = !!r2;

        if (savedPiKey) {
          // if the cookies have pikey, check if its the same
          if (urlPiKey && savedPiKey !== urlPiKey) {
            nativeStorageInterface.remove("introComplete");
            introComplete = false;
          } else if (!urlPiKey) {
            // if there is no piKey in the url, just use the saved one!
            props.setPiKeyState(savedPiKey);
          }
        } else {
          introComplete = false;
          nativeStorageInterface.remove("introComplete");
        }

        if (urlPiKey) {
          nativeStorageInterface.set("piKey", urlPiKey);
        }

        if (piKey && noIntro) {
          introComplete = true;
        }

        if (introComplete) {
          if (!props.location.pathname.includes(`/${pageNames.intro}/`)) {
            props.history.push(`${props.location.pathname}${getQueryParams()}`);
          }

          props.completeIntro();
          return;
        } else {
          if (
            !props.history.location.pathname.includes(pageNames.selectLanguage)
          ) {
            history.push(`/${pageNames.intro}/${getQueryParams()}`);
          }
        }
      });
    });
  };

  useEffect(handlePageDirect, [props.piKeyState]);
}
